import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-nfl-avb',
    templateUrl: './default/nfl-avb/nfl-avb.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class NflAvbComponent extends UnitsDistributionBase {
  // Used for NFL_AVB
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}